/* Brotherly Sole v15: one-time scroll reveal. Tiny, no dependencies. */
(function(){
  var els=document.querySelectorAll('.lx-r');
  if(!els.length)return;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window)){for(var i=0;i<els.length;i++)els[i].classList.add('is-in');return}
  var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.12});
  for(var j=0;j<els.length;j++)io.observe(els[j]);
})();
/* v23: on phones the menu button copies the cart button exactly: same circle, size, colors, outline,
   the same distance from the screen edge, and the same height on the page. */
(function(){
  var d=document;
  function shapeOf(link){
    var els=[link].concat([].slice.call(link.querySelectorAll('*')));
    for(var i=0;i<els.length;i++){var e=els[i];if(e.closest('.cart-link__bubble')||e.tagName==='IMG'||e.tagName==='svg')continue;
      var bg=getComputedStyle(e).backgroundColor;if(bg&&bg!=='transparent'&&!/rgba\(\s*0,\s*0,\s*0,\s*0\s*\)/.test(bg)&&e.offsetWidth)return e}
    return link;
  }
  function set(el,p,v){el.style.setProperty(p,v,'important')}
  function sync(){
    var btn=d.querySelector('.my_site-nav__thumb-menu .js-toggle-slide-nav'),cart=d.querySelector('.header-item--icons .site-nav__link--cart');
    if(!btn||!cart)return;
    if(window.innerWidth>768||!cart.offsetWidth||!btn.offsetWidth){btn.removeAttribute('data-lx-hdr');return}
    var sh=shapeOf(cart),s=getComputedStyle(sh),r=sh.getBoundingClientRect();
    if(!r.width)return;
    set(btn,'width',r.width+'px');set(btn,'height',r.height+'px');set(btn,'min-width','0');set(btn,'min-height','0');set(btn,'padding','0');
    set(btn,'border-radius',s.borderTopLeftRadius==='0px'?'50%':s.borderTopLeftRadius);
    set(btn,'background',s.backgroundColor);set(btn,'background-color',s.backgroundColor);
    set(btn,'border',s.borderTopWidth+' '+s.borderTopStyle+' '+s.borderTopColor);
    set(btn,'box-shadow',s.boxShadow);set(btn,'display','inline-flex');set(btn,'align-items','center');set(btn,'justify-content','center');
    set(btn,'color',s.borderTopWidth!=='0px'?s.borderTopColor:'#10291c');
    [].forEach.call(btn.querySelectorAll('.icon'),function(i){set(i,'width',Math.round(r.width*.48)+'px');set(i,'height',Math.round(r.width*.48)+'px')});
    /* same gap from the left edge as the cart has from the right edge, and the same vertical center */
    set(btn,'transform','none');set(btn,'margin-left','0');set(btn,'position','relative');set(btn,'top','0');
    var w=d.documentElement.clientWidth,b=btn.getBoundingClientRect(),gap=w-r.right;
    set(btn,'margin-left',(gap-b.left)+'px');
    b=btn.getBoundingClientRect();
    set(btn,'top',((r.top+r.height/2)-(b.top+b.height/2))+'px');
    btn.setAttribute('data-lx-hdr','1');
  }
  function go(){sync();requestAnimationFrame(sync)}
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',go);else go();
  window.addEventListener('load',go);
  var t;window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(sync,120)});
})();
/* v24: phone menu: an X to close it, and the panel sits right on the bottom edge (no empty space under "Log in"). */
(function(){
  var d=document;
  function panel(){return d.querySelector('.slide-nav__overflow--thumb')}
  function toggle(){return d.querySelector('.my_site-nav__thumb-menu .js-toggle-slide-nav')}
  function set(el,p,v){el.style.setProperty(p,v,'important')}
  function setup(){
    var p=panel();if(!p||p.dataset.lxNav)return;p.dataset.lxNav='1';
    var x=d.createElement('button');x.type='button';x.className='lx-navx';x.setAttribute('aria-label','Close menu');
    x.innerHTML='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    x.addEventListener('click',function(e){e.preventDefault();var t=toggle();if(t)t.click()});
    p.insertBefore(x,p.firstChild);
    /* pin to the bottom only when the theme hides the panel some other way than moving its bottom edge */
    var cs=getComputedStyle(p);
    if(cs.transform!=='none'||cs.visibility==='hidden'||parseFloat(cs.opacity)===0){set(p,'bottom','0');set(p,'margin-bottom','0')}
    else{p.dataset.lxShift='1'}
  }
  function shift(){var p=panel();if(!p||!p.dataset.lxShift||window.innerWidth>768)return;var r=p.getBoundingClientRect(),h=window.innerHeight,t=parseFloat(p.dataset.lxT||'0'),gap=h-(r.bottom-t);
    if(r.top<h-20&&gap>0&&gap<300){p.dataset.lxT=String(gap);set(p,'translate','0 '+gap+'px')}}
  d.addEventListener('click',function(e){var t=e.target;if(t&&t.closest&&t.closest('.js-toggle-slide-nav')){setTimeout(shift,350);setTimeout(shift,700)}},true);
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',setup);else setup();
  window.addEventListener('load',setup);
})();
